export const COPY = {
  openApp: 'Open app',
  cta: 'Get Quade to join',
  ctaClub: 'Get Quade to join the club',
  ctaCaptionLead: 'Free · ',
  ctaCaptionStrong: 'We’ll bring you right back to this invite',
  // iOS: no clipboard handoff; the Universal Link reopens the app on the invite.
  ctaCaptionStrongIos: 'After installing, tap your invite link again',
  inAppNote: 'Already have Quade? Open it from here.',
  inAppOpen: 'Open',
  notInstalled: 'Quade isn’t installed on this phone yet.',
  nextUp: 'Next up',
  about: 'About',
  more: 'More',
  less: 'Less',
  alsoComingUp: 'Also coming up',
  invited: 'You’re invited',
  cancelledBadge: 'Cancelled',
  endedBadge: 'Ended',
  eventPassed: 'This event has passed. Next up:',
  eventPassedNoNext: 'This event has passed.',
  newToQuade: 'New to Quade?',
  whatIsQuade:
    'Quade is where readers save the lines that stay with them and read along with friends. Free on iPhone and Android.',
  revokedTitle: 'This invite link is turned off',
  privateTitle: 'This club is private',
  privateOpenApp: 'Already a member? Open Quade',
  errorTitle: 'We couldn’t load this invite',
  errorBody: 'Check your connection and try again.',
  rateLimitedBody: 'Too many requests. Wait a moment and try again.',
  retry: 'Try again',
  loadFailedTitle: 'We couldn’t load this page',
  loadFailedBody: 'Check your connection and reload.',
  reload: 'Reload',
  loading: 'Loading invite',
  desktopTitle: 'Continue on your phone',
  desktopBody: 'Quade opens this invite right after you install it.',
  qrCaption: 'Point your camera at the code',
  or: 'or',
  emailLabel: 'Email me the link',
  emailPlaceholder: 'you@example.com',
  send: 'Send',
  useDifferentEmail: 'Use a different email',
  sending: 'Sending…',
  emailInvalid: 'Enter a valid email address.',
  emailRateLimited: 'Too many requests. Try again in a little while.',
  emailFailed: 'We couldn’t send that. Try again.',
  freeOnStores: 'Free on iPhone and Android',
  clubPublic: 'Public',
  clubPrivate: 'Private',
  formatByob: 'Bring your own book',
  formatShared: 'Shared read',
  organizerFallback: 'The organizer',
  sampleQuote: '“A book must be the axe for the frozen sea within us.”',
  sampleQuoteAuthor: 'Franz Kafka',
} as const;

export const invitedBy = (name: string) => `${name} invited you`;
export const members = (count: number) => (count === 1 ? '1 member' : `${count} members`);
export const going = (count: number) => `${count} going`;
export const askForInvite = (organizer: string) => `Use the invite link ${organizer} sent you, or ask them for a new one.`;
export const askForNewLink = (organizer: string) => `Ask ${organizer} to send you a fresh link.`;
export const cancelledNote = (organizer: string) => `${organizer} cancelled this event. The club is still open.`;
export const sentTo = (email: string) => `If ${email} can receive email, the link is on its way. Open it on your phone.`;
export const othersLine = (names: string[], total: number) => {
  const shown = names.slice(0, 2);
  if (shown.length === 0) {
    return members(total);
  }
  const others = Math.max(total - shown.length, 0);
  if (others === 0) {
    return shown.join(' and ');
  }
  const rest = others === 1 ? '1 other' : `${others} others`;
  return `${shown.join(', ')} and ${rest}`;
};
export const hostedBy = (organizer: string) => `Hosted by ${organizer}`;
export const formatLabel = (format: string) => (format === 'BRING_YOUR_OWN_BOOK' ? COPY.formatByob : COPY.formatShared);
